// utils/SocketService.js
import { io } from 'socket.io-client';
import LoggedInUserService from './AuthService'

let socket;

export const initializeSocket = () => {
  if (!socket) {
    const tdata = LoggedInUserService.GetLoggedInUserData();
    if(!tdata){return false}
    socket = io(process.env.REACT_APP_PFQ_BASE_URL, {
      query: { id: tdata?.id },
      reconnection: true,
      withCredentials: true,
    });

    socket.on('connect', () => {
      console.log('Connected to Socket.IO server.');
    });
  }
  return socket;
};

export const getSocket = () => socket;

export const onSocketEvent = (eventName, callback) => {
  if (socket) {
    socket.on(eventName, callback);
  }
};

export const offSocketEvent = (eventName, callback) => {
  if (socket) {
    socket.off(eventName, callback);
  }
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
